import React, { PureComponent } from 'react';
import { acceptTeamInvitation } from '../../../../store/team/api';

export const PENDING_TEAM_INVITATION_KEY = 'pendingTeamInvitationId';

function readRouteInvitationId(props) {
  return (props.match && props.match.params && props.match.params.Id) || '';
}

class AcceptTeamInvitation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      invitationId: readRouteInvitationId(props) || sessionStorage.getItem(PENDING_TEAM_INVITATION_KEY) || '',
      phase: 'waiting',
      errorCode: null
    };
    this.acceptStarted = false;
  }

  componentDidMount() {
    this.syncInvitationFlow();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isAuthenticated !== this.props.isAuthenticated ||
      prevProps.initialAuthDone !== this.props.initialAuthDone
    ) {
      this.syncInvitationFlow();
    }
  }

  syncInvitationFlow() {
    const { isAuthenticated, initialAuthDone, history } = this.props;
    const invitationId = this.state.invitationId;

    if (!invitationId) {
      if (this.state.phase !== 'missing') {
        this.setState({ phase: 'missing' });
      }
      return;
    }

    if (!initialAuthDone) {
      return;
    }

    if (!isAuthenticated) {
      sessionStorage.setItem(PENDING_TEAM_INVITATION_KEY, invitationId);
      history.replace(`/login?next=${encodeURIComponent(`/accpetInvitation/${invitationId}`)}`);
      return;
    }

    if (this.acceptStarted) {
      return;
    }
    this.acceptStarted = true;
    this.acceptOnce(invitationId);
  }

  async acceptOnce(invitationId) {
    try {
      const payload = await acceptTeamInvitation({ invitationId });
      if (payload && payload.success) {
        sessionStorage.removeItem(PENDING_TEAM_INVITATION_KEY);
        this.setState({ phase: 'accepted' });
        return;
      }
      const code = (payload && payload.code) || 'INVITATION-FAILED';
      if (code === 'INVITATION-ALREADY-USED') {
        sessionStorage.removeItem(PENDING_TEAM_INVITATION_KEY);
      }
      this.setState({
        phase: code === 'INVITATION-ALREADY-USED' ? 'used' : 'failed',
        errorCode: code
      });
    } catch (error) {
      if (error && error.cancelled) {
        return;
      }
      const code = (error && error.code) || 'INVITATION-FAILED';
      if (code === 'INVITATION-ALREADY-USED') {
        sessionStorage.removeItem(PENDING_TEAM_INVITATION_KEY);
        this.setState({ phase: 'used', errorCode: code });
        return;
      }
      this.setState({ phase: 'failed', errorCode: code });
    }
  }

  messageId() {
    switch (this.state.phase) {
      case 'missing':
        return 'Invitation is missing or invalid';
      case 'waiting':
        return 'Accepting the team invitation';
      case 'used':
        return 'Invitation is no longer available';
      case 'failed':
        return 'Unable to accept the invitation';
      default:
        return 'You have accepted the invitation to join the team';
    }
  }

  render() {
    const { intl } = this.props;

    return (
      <div>
        <div id="loginWrapper">
          <div className="page-containt">
            <img alt="" style={{ marginTop: '125px' }} className="logo" src="img/logo_kyc.png" />
            <div className="consent-style">
              <p>{intl.formatMessage({ id: this.messageId() })}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AcceptTeamInvitation;
